import { render } from "./ChooseRole.vue?vue&type=template&id=280eccdc"
import script from "./ChooseRole.vue?vue&type=script&lang=js"
export * from "./ChooseRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__